import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import Emittery from "emittery";
import { VueReCaptcha } from "vue-recaptcha-v3";
import "@/core/plugins/prismjs";
import "bootstrap";
const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus);

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY,
  loaderOptions: {
    useRecaptchaNet: true,
  },
});
Emittery.isDebugEnabled = true;
app.config.globalProperties.$msalInstance = {};
app.config.globalProperties.$emitter = new Emittery({
  debug: { name: "seccuriApp" },
});

app.mount("#app");
